import { createAction, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { ToggleMuteActionInterface } from '../../types';

type DeviceState = {
    audioIsTemporarilyUnMuted: boolean;
};

const initialState: DeviceState = {
    audioIsTemporarilyUnMuted: false,
};

const deviceSlice = createSlice({
    name: 'device',
    initialState,
    reducers: {
        setAudioIsTemporarilyUnMuted(state, action: PayloadAction<boolean>) {
            state.audioIsTemporarilyUnMuted = action.payload;
        },
        resetDeviceState() {
            return initialState;
        },
    },
});
export const toggleMuteAction = createAction<ToggleMuteActionInterface>('conference/device/toggleMute');
export const { setAudioIsTemporarilyUnMuted, resetDeviceState } = deviceSlice.actions;
export const deviceReducer = deviceSlice.reducer;
